<script>
    import { getOfferV2 } from '../clients/OfferClientV2.svelte';
    import { store, store_offer } from '../Store.svelte';
    import { env } from '../Environment.svelte';
    import Preloader from '../components/Preloader.svelte';

    const token = window.location.pathname.replace('/receiver/purchase/', '');

    if (token != null) {
        try {
            const base64Decoded = atob(token);
            const urlDecoded = decodeURIComponent(base64Decoded);
            const receivedUserData = JSON.parse(urlDecoded);

            selectOffer(receivedUserData);
        } catch (e) {
            console.log(e);
        }
    }

    async function selectOffer(receivedUserData) {
        let requestedAddress = receivedUserData.requestedAddress;
        let productId = receivedUserData.productId;
        let izzimovil = receivedUserData.izziMovil;
        let productFamily = receivedUserData.productFamily;

        try {
            const offerData = await getOfferV2(
                requestedAddress.postalCode,
                requestedAddress.latitude,
                requestedAddress.longitude,
                requestedAddress.offnetCoverage,
                requestedAddress.offnetIzziCoverage
            );

            $store_offer.loadedOffer = offerData;

            Object.assign(
                $store.requestedAddress,
                receivedUserData.requestedAddress
            );
            Object.assign(
                $store.requestedServices,
                receivedUserData.requestedServices
            );
            await searchOffer(productId);
            $store.requestedServices.izzimovil = izzimovil;
            $store.requestedServices.product.productFamily = productFamily;
            $store.requestedAddress.addressRPT = offerData.rptCode;

            redirect();
        } catch (error) {
            console.error('Error fetching offer data:', error);
        }
    }

    function searchOffer(productId) {
        let paqIds = [];
        const offerKeys = Object.keys($store_offer.loadedOffer.offers);

        offerKeys.forEach((key) => {
            const offersArray = $store_offer.loadedOffer.offers[key];

            if (Array.isArray(offersArray)) {
                offersArray.forEach((offer) => {
                    if (offer.paqId === productId) {
                        paqIds.push(offer);
                    }
                });

                const filteredIds = offersArray
                    .filter((offer) => offer.productId === productId)
                    .map((offer) => offer.paqId);

                paqIds.push(...filteredIds);
            }
        });

        $store.requestedServices.productId = productId;
        $store.requestedServices.product = paqIds[0];
    }

    function redirect() {
        window.top.location.href = env[env.stage].urlweb + '/compra/configura';
    }
</script>

<div class="loader-overlay">
    <Preloader
        status="Estamos buscando las mejores promociones y canales para ti. Un momento, por favor."
    />
</div>
